import React, { FC, useMemo } from 'react';
import * as classes from './NavItem.module.scss';
import cn from 'classnames';
import Link from '../../Link/Link';

interface Props {
  path: string;
  isVerticalItem?: boolean;
  withSeparator?: boolean;
  title?: string;
  isExternalLink?: boolean;
  isTargetBlank?: boolean;
  clickAction?: () => void;
}

const NavItem: FC<Props> = ({ path, isVerticalItem, clickAction, title, withSeparator, children, isExternalLink, isTargetBlank }) => {
  const itemClassNames = useMemo(() => {
    if (isVerticalItem) {
      return cn(classes.element, classes.vertical);
    }
    if (withSeparator && !isVerticalItem) {
      return cn(classes.element, classes.horizontal, classes.withSeparator);
    }
    return cn(classes.element, classes.horizontal, classes.mainNav);
  }, [isVerticalItem, withSeparator]);

  return (
    <li className={itemClassNames} onClick={clickAction}>
      <Link path={path} activeClassName={classes.activeNav} title={title} isExternalLink={isExternalLink} isTargetBlank={isTargetBlank}>
        {children}
      </Link>
    </li>
  );
};

export default NavItem;
